// extracted by mini-css-extract-plugin
export default {"pageDescription":"MergeDuplicates_pageDescription__NTfBR"};